$(document).ready(function () {
  $('#submit').click(function (e) {
            var isValid = true;
            $('#contact_name,#contact_email,#ContactFormQunatity').each(function () {
              var first_name = $('#contact_email').val();
              var email = $('#contact_email').val();
              var quantity = $('#ContactFormQunatity').val();
              $(".error").remove();

    if (first_name.length < 1) {
       isValid = false;
      $('#contact_name').after('<span class="error">This field is required</span>');
    }
    if (email.length < 1) {
       isValid = false;
      $('#contact_email').after('<span class="error">This field is required</span>');
    }
   else {
       var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
      if(!emailReg.test(email)) { 
        isValid = false;
        $('#contact_email').after('<span class="error">Enter a valid email</span>');
   }   
   }
              if (quantity.length < 1) {
                 isValid = false;
      $('#ContactFormQunatity').after('<span class="error">This field is required</span>');
    }
// 	        if ($.trim($(this).val()) == '') {
//                     isValid = false;
//                   $('#contact_name').after('<span class="error">This field is required</span>');
//               		$('#contact_email').after('<span class="error">This field is required</span>');
//               		$('#ContactFormQunatity').after('<span class="error">This field is required</span>');
// //                     $(this).css({
// //                         "border": "1px solid red",
// //                         "background": "#FFCECE"
// //                     });
//                 }
               
              
               
            });
            if (isValid == false)
                e.preventDefault();

        });
});